import firebase from './'

const analytics = firebase.analytics()

type TEvent = 'Login' | 'Register' | 'Create Farm' | 'Select Farm' | 'Select Pin' | 'Create Pin'

export function logEvent(eventName: TEvent): void { analytics.logEvent(eventName) }